/**
 * Alunos fictícios para demo offline. `photo` é um data-URL SVG (iniciais + cor),
 * estável e sem chamadas a CDN.
 */

const DEMO_NAMES = [
  "Ana Carolina Silva",
  "Bruno Mendes Costa",
  "Carla Ferreira Lima",
  "Daniel Oliveira Santos",
  "Eduarda Martins Rocha",
  "Felipe Alves Nunes",
  "Gabriela Souza Dias",
  "Henrique Pereira Lopes"
];

function hashString(s) {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (31 * h + s.charCodeAt(i)) % 1000000007;
  }
  return h;
}

function initialsFromName(name) {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    const a = parts[0][0];
    const b = parts[parts.length - 1][0];
    return `${a}${b}`.toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

/**
 * Avatar circular com iniciais; cor derivada do nome (HSL).
 * @param {string} name
 * @returns {string} data:image/svg+xml URL
 */
export function demoAvatarDataUrl(name) {
  const initials = initialsFromName(name || "?");
  const hue = hashString(name) % 360;
  const bg = `hsl(${hue} 42% 88%)`;
  const fg = `hsl(${hue} 45% 28%)`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><rect width="96" height="96" rx="48" fill="${bg}"/><text x="48" y="56" font-family="system-ui,-apple-system,sans-serif" font-size="28" font-weight="600" text-anchor="middle" fill="${fg}">${initials}</text></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

/** YYYYMM (ano e mês correntes), ex.: 202604 */
function currentYearMonthPrefix() {
  const d = new Date();
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/**
 * RA: ano (4) + mês (2) + sequencial (3), ex.: 202604001
 * @param {string} classId
 * @returns {Array<{ id: string, name: string, ra: string, photo: string }>}
 */
export function buildDemoStudentsForClass(classId) {
  if (classId !== "DEMO-T1") {
    return [];
  }

  const prefix = currentYearMonthPrefix();

  return DEMO_NAMES.map((name, index) => {
    const seq = String(index + 1).padStart(3, "0");
    const ra = `${prefix}${seq}`;
    return {
      id: ra,
      ra,
      rollCallNum: index + 1,
      name,
      photo: demoAvatarDataUrl(name)
    };
  });
}
